import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { IContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder/pageBuilder.domains'

import { ProductSectionType } from '../../types/productPage.types'
import {
  DESKTOP_FAQ,
  DESKTOP_FBT,
  DESKTOP_INFLUENCER,
  DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
  DESKTOP_PRODUCT_REVIEWS,
  DESKTOP_SIMILAR_PRODUCTS,
  DESKTOP_TRANSPARENT_PRICING,
  DESKTOP_YOU_MAY_ALSO_LIKE,
  DESKTOP_DISCLAIMER,
} from '../common'
import {
  MOBILE_REVIEW_HIGHLIGHTS,
  MOBILE_PRODUCT_DETAILS_AND_CARE,
  MOBILE_BRAND_COMPARISON,
  MOBILE_PAIR_WITH,
  MOBILE_SIMILAR_PRODUCTS,
  MOBILE_TRANSPARENT_PRICING,
  MOBILE_INFLUENCER,
  MOBILE_INFORMATION_BOXES,
  MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
  MOBILE_PRODUCT_REVIEWS,
  MOBILE_YOU_MAY_ALSO_LIKE,
  MOBILE_DISCLAIMER,
} from '../common/mobile'

export const bundleLongFormDesktopConfig: IContainerConfig = {
  id: 'DESKTOP_BUNDLE_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    {
      id: 'BUNDLE_PRODUCT_IMAGES_AND_PURCHASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.BUNDLE_PRODUCT_IMAGES_AND_PURCHASE,
      },
    },
    DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
    DESKTOP_SIMILAR_PRODUCTS,
    DESKTOP_PRODUCT_REVIEWS,
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_2,
      },
    },
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE_SCALE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_4,
      },
    },
    {
      id: 'DESKTOP_PRODUCT_COMPARISON',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_7,
      },
    },
    DESKTOP_FBT,
    DESKTOP_TRANSPARENT_PRICING,
    DESKTOP_INFLUENCER,
    DESKTOP_FAQ,
    DESKTOP_YOU_MAY_ALSO_LIKE,
    DESKTOP_DISCLAIMER,
  ],
}

export const bundleLongFormMobileConfig: IContainerConfig = {
  id: 'MOBILE_BUNDLE_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    {
      id: 'MOBILE_BUNDLE_PRODUCT_IMAGES_AND_PURCHASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.BUNDLE_PRODUCT_IMAGES_AND_PURCHASE,
      },
    },
    MOBILE_REVIEW_HIGHLIGHTS,
    MOBILE_PRODUCT_DETAILS_AND_CARE,
    MOBILE_BRAND_COMPARISON,
    MOBILE_PAIR_WITH,
    {
      id: 'DESKTOP_PRODUCT_SHOWCASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_2,
      },
    },
    {
      id: 'MOBILE_PRODUCT_SHOWCASE_SCALE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_4,
      },
    },
    {
      id: 'MOBILE_PRODUCT_COMPARISON',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.FEATURE_SECTION_7,
      },
    },
    MOBILE_SIMILAR_PRODUCTS,

    MOBILE_TRANSPARENT_PRICING,
    MOBILE_INFLUENCER,
    MOBILE_INFORMATION_BOXES,
    MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
    MOBILE_PRODUCT_REVIEWS,
    MOBILE_YOU_MAY_ALSO_LIKE,
    MOBILE_DISCLAIMER,
  ],
}
